import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    INICIA_NOTAS_FALTAS,
    BUSCA_NOTAS_FALTAS,
    LISTA_CURSOS_NOTAS_FALTAS,
    LISTA_SERIES_NOTAS_FALTAS,
    LISTA_TURMAS_NOTAS_FALTAS,
    LISTA_ETAPAS_NOTAS_FALTAS,
    LISTA_DISCIPLINAS_NOTAS_FALTAS,
    LISTA_MATRICULAS_NOTAS_FALTAS,
    SALVA_NOTA_FALTA,
    SALVA_PARECER_DESCRITIVO,
    SALVA_NOTA_CONSELHO,
    SALVA_NOTA_RECUPERACAO,
    SALVA_SITUACAO_MATRICULA,
    ON_HIDE_LOADER
} from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import {
    inicioNotasFaltasSucesso,
    buscaNotasFaltasSucesso,
    listaCursosNotasFaltasSucesso,
    listaSeriesNotasFaltasSucesso,
    listaTurmasNotasFaltasSucesso,
    listaEtapasNotasFaltasSucesso,
    listaDisciplinasNotasFaltasSucesso,
    listaMatriculasNotasFaltasSucesso,
    showAuthMessage,
    showSuccessMessage,
    salvaNotaFaltaSucesso,
    salvaParecerDescritivoSucesso,
    salvaNotaConselhoSucesso,
    salvaNotaRecuperacaoSucesso,
    salvaSituacaoMatriculaSucesso
} from "actions/NotasFaltas";

/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

const getEscolas = async () =>
    await requisicaoApi.get('/escolas')
        .then(resposta => resposta)
        .catch(error => error);

const getCursosPorEscolaAnoLetivo = async (escolaId, anoLetivo) =>
    await requisicaoApi.get(`/escolas/${escolaId}/cursos`, { params: { anoLetivo } })
        .then(resposta => resposta)
        .catch(error => error);

const getSeriesPorCurso = async (cursoId) =>
    await requisicaoApi.get('/series', { params: { CursoId: cursoId } })
        .then(resposta => resposta)
        .catch(error => error);

const getTurmasPorFiltros = async (ano, escolaId, serieId) =>
    await requisicaoApi.get('/turmas', { params: { Ano: ano, EscolaId: escolaId, SerieId: serieId } })
        .then(resposta => resposta)
        .catch(error => error);

const getEtapasAnoLetivo = async (escolaId, anoLetivo) =>
    await requisicaoApi.get(`/escolas/${escolaId}/etapas-ano-letivo`, { params: { anoLetivo } })
        .then(resposta => resposta)
        .catch(error => error);

const getDisciplinasDisponiveis = async (escolaId, serieId, anoLetivo) =>
    await requisicaoApi.get('/turmas/disciplinas-disponiveis', { params: { escolaId, serieId, ano: anoLetivo } })
        .then(resposta => resposta)
        .catch(error => error);

const getMatriculasPorTurma = async (turmaId, anoLetivo) =>
    await requisicaoApi.get('/matriculas', { params: { TurmaId: turmaId, Ano: anoLetivo, Situacao: 'Cursando,Aprovado,Retido,Reprovado,Aprovado por conselho,Aprovado com dependência,Reprovado por faltas' } })
        .then(resposta => resposta)
        .catch(error => error);

const buscarNotasFaltas = async (filtros) =>
    await requisicaoApi.get('/notas-faltas', { params: filtros })
        .then(resposta => resposta)
        .catch(error => error);

const buscarNotasFaltasPorDisciplina = async (filtros) =>
    await requisicaoApi.get('/notas-faltas/por-disciplina', { params: filtros })
        .then(resposta => resposta)
        .catch(error => error);

const buscarNotasFaltasPorMatricula = async (filtros) =>
    await requisicaoApi.get('/notas-faltas/por-matricula', { params: filtros })
        .then(resposta => resposta)
        .catch(error => error);

// POST para salvar nota/falta individual
const postSalvaNotaFalta = async (dados) =>
    await requisicaoApi.post('/notas-faltas', dados)
        .then(resposta => resposta)
        .catch(error => error);

// POST para salvar parecer descritivo
const postSalvaParecerDescritivo = async (dados) =>
    await requisicaoApi.post('/pareceres-descritivos', dados)
        .then(resposta => resposta)
        .catch(error => error);

// POST para salvar nota do conselho
const postSalvaNotaConselho = async (dados) =>
    await requisicaoApi.post('/notas-conselho', dados)
        .then(resposta => resposta)
        .catch(error => error);

// POST para salvar nota de recuperação
const postSalvaNotaRecuperacao = async (dados) =>
    await requisicaoApi.post('/notas-recuperacao', dados)
        .then(resposta => resposta)
        .catch(error => error);

// PUT para atualizar situação da matrícula
const putAtualizaSituacaoMatricula = async (dados) =>
    await requisicaoApi.put(`/matriculas/${dados.matriculaId}/situacao`, dados)
        .then(resposta => resposta)
        .catch(error => error);



/*#################################################################################################################*/
/* ------------------------------------------ Funções das Sagas ---------------------------------------------------*/

const extractErrorMessage = (error, mensagemPadrao) => {
    if (!error) return mensagemPadrao;

    const response = error.response;
    const status = response?.status;
    const responseData = response?.data;

    // Se for erro 400 (validação), tentar extrair inconsistências
    if (status === 400 && responseData) {
        const inconsistencias = responseData.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
            return inconsistencias[0].mensagem || mensagemPadrao;
        }
        if (responseData.mensagem) {
            return responseData.mensagem;
        }
        if (responseData.message) {
            return responseData.message;
        }
    }

    // Tentar outras formas de extrair a mensagem
    if (responseData?.mensagem) return responseData.mensagem;
    if (responseData?.message) return responseData.message;
    if (error.message) return error.message;

    return mensagemPadrao;
};

function* fnIniciaNotasFaltas() {
    try {
        const retorno = yield call(getEscolas);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao buscar escolas');
            yield put(showAuthMessage(mensagem));
        } else {
            const data = retorno.data;
            const escolas = Array.isArray(data) ? data : (Array.isArray(data?.escolas) ? data.escolas : []);
            yield put(inicioNotasFaltasSucesso(escolas));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao buscar escolas');
        yield put(showAuthMessage(mensagem));
    } finally {
        yield put({ type: ON_HIDE_LOADER });
    }
}

function* fnListaCursosNotasFaltas({ payload }) {
    try {
        const { escolaId, anoLetivo } = payload;
        if (!escolaId || Number(escolaId) === 0) {
            yield put(listaCursosNotasFaltasSucesso([]));
            return;
        }
        const retorno = yield call(getCursosPorEscolaAnoLetivo, escolaId, anoLetivo);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar cursos');
            yield put(showAuthMessage(mensagem));
        } else {
            const data = retorno.data;
            const cursos = Array.isArray(data) ? data : (Array.isArray(data?.cursos) ? data.cursos : (Array.isArray(data?.Cursos) ? data.Cursos : []));
            yield put(listaCursosNotasFaltasSucesso(cursos));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar cursos');
        yield put(showAuthMessage(mensagem));
    }
}

function* fnListaSeriesNotasFaltas({ payload }) {
    try {
        const { cursoId } = payload;
        if (!cursoId || Number(cursoId) === 0) {
            yield put(listaSeriesNotasFaltasSucesso([]));
            return;
        }
        const retorno = yield call(getSeriesPorCurso, cursoId);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar séries');
            yield put(showAuthMessage(mensagem));
        } else {
            const data = retorno.data;
            const series = Array.isArray(data) ? data : (Array.isArray(data?.series) ? data.series : (Array.isArray(data?.Series) ? data.Series : []));
            yield put(listaSeriesNotasFaltasSucesso(series));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar séries');
        yield put(showAuthMessage(mensagem));
    }
}

function* fnListaTurmasNotasFaltas({ payload }) {
    try {
        const { ano, escolaId, serieId } = payload;
        if (!ano || !escolaId || !serieId) {
            yield put(listaTurmasNotasFaltasSucesso([]));
            return;
        }
        const retorno = yield call(getTurmasPorFiltros, ano, escolaId, serieId);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar turmas');
            yield put(showAuthMessage(mensagem));
        } else {
            const data = retorno.data;
            const turmas = Array.isArray(data) ? data : (Array.isArray(data?.turmas) ? data.turmas : (Array.isArray(data?.Turmas) ? data.Turmas : []));
            yield put(listaTurmasNotasFaltasSucesso(turmas));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar turmas');
        yield put(showAuthMessage(mensagem));
    }
}

function* fnListaEtapasNotasFaltas({ payload }) {
    try {
        const { escolaId, anoLetivo } = payload;
        if (!escolaId || !anoLetivo) {
            yield put(listaEtapasNotasFaltasSucesso([]));
            return;
        }
        const retorno = yield call(getEtapasAnoLetivo, escolaId, anoLetivo);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar etapas');
            yield put(showAuthMessage(mensagem));
        } else {
            const data = retorno.data;
            const etapas = Array.isArray(data) ? data : (Array.isArray(data?.etapas) ? data.etapas : (Array.isArray(data?.Etapas) ? data.Etapas : []));
            yield put(listaEtapasNotasFaltasSucesso(etapas));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar etapas');
        yield put(showAuthMessage(mensagem));
    }
}

function* fnListaDisciplinasNotasFaltas({ payload }) {
    try {
        const { escolaId, serieId, anoLetivo } = payload;
        if (!escolaId || !serieId || !anoLetivo) {
            yield put(listaDisciplinasNotasFaltasSucesso([]));
            return;
        }
        const retorno = yield call(getDisciplinasDisponiveis, escolaId, serieId, anoLetivo);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar disciplinas');
            yield put(showAuthMessage(mensagem));
        } else {
            const data = retorno.data;
            const disciplinas = Array.isArray(data) ? data : (Array.isArray(data?.componentes) ? data.componentes : (Array.isArray(data?.disciplinas) ? data.disciplinas : []));
            yield put(listaDisciplinasNotasFaltasSucesso(disciplinas));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar disciplinas');
        yield put(showAuthMessage(mensagem));
    }
}

function* fnListaMatriculasNotasFaltas({ payload }) {
    try {
        const { turmaId, anoLetivo } = payload;
        if (!turmaId || !anoLetivo) {
            yield put(listaMatriculasNotasFaltasSucesso([]));
            return;
        }
        const retorno = yield call(getMatriculasPorTurma, turmaId, anoLetivo);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar matrículas');
            yield put(showAuthMessage(mensagem));
        } else {
            const data = retorno.data;
            const matriculas = Array.isArray(data) ? data : (Array.isArray(data?.matriculas) ? data.matriculas : (Array.isArray(data?.Matriculas) ? data.Matriculas : []));
            yield put(listaMatriculasNotasFaltasSucesso(matriculas));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar matrículas');
        yield put(showAuthMessage(mensagem));
    }
}

function* fnBuscaNotasFaltas({ payload }) {
    try {
        let retorno;

        // Se disciplinaId está selecionado, usa endpoint por-disciplina
        // Usar periodoAnoLetivoId do payload (botão Próximo) ou fallback para etapaId (filtro inicial)
        const periodoId = payload.periodoAnoLetivoId || payload.etapaId;

        if (payload.matriculaId) {
            // Endpoint por matrícula - mostra todas disciplinas do aluno
            // PRIORIDADE: Se matrícula estiver selecionada, busca por matrícula (mesmo que disciplina esteja selecionada)
            const filtros = {
                anoLetivo: payload.anoLetivo,
                escolaId: payload.escolaId,
                cursoId: payload.cursoId,
                serieId: payload.serieId,
                turmaId: payload.turmaId,
                periodoAnoLetivoId: periodoId,
                matriculaId: payload.matriculaId,
                disciplinaId: payload.disciplinaId
            };
            retorno = yield call(buscarNotasFaltasPorMatricula, filtros);
        } else if (payload.disciplinaId) {
            const filtros = {
                anoLetivo: payload.anoLetivo,
                escolaId: payload.escolaId,
                cursoId: payload.cursoId,
                serieId: payload.serieId,
                turmaId: payload.turmaId,
                periodoAnoLetivoId: periodoId,
                disciplinaId: payload.disciplinaId
            };
            retorno = yield call(buscarNotasFaltasPorDisciplina, filtros);
        } else {
            yield put(showAuthMessage('É necessário selecionar uma disciplina ou matrícula.'));
            return;
        }

        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao buscar notas/faltas');
            yield put(showAuthMessage(mensagem));
        } else {
            const data = retorno.data || {};
            const resultado = {
                dadosCabecalho: data.dadosCabecalho || data || {},
                listaLancamentos: data.listaLancamentos || [],
                proximaEtapaId: data.proximaEtapaId || data.dadosCabecalho?.proximaEtapaId || null,
                etapaAnteriorId: data.etapaAnteriorId || data.dadosCabecalho?.etapaAnteriorId || null,
                regrasAvaliacao: data.regrasAvaliacao || data.dadosCabecalho?.regrasAvaliacao || null
            };
            yield put(buscaNotasFaltasSucesso(resultado));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao buscar notas/faltas');
        yield put(showAuthMessage(mensagem));
    } finally {
        yield put({ type: ON_HIDE_LOADER });
    }
}

// Saga para salvar nota/falta individual
function* fnSalvaNotaFalta({ payload }) {
    try {
        const retorno = yield call(postSalvaNotaFalta, payload);

        // Verificar se houve erro na resposta
        if (retorno.response || retorno.message || (retorno.mensagem && !retorno.data)) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao salvar');
            yield put(showAuthMessage(mensagem));
        } else {
            // Sucesso
            const dados = retorno.data && retorno.data.dados;

            // Quando a composição é arredondada pela regra, avisar a nota informada x salva
            if (dados && (dados.notaAjustadaPorArredondamento || dados.NotaAjustadaPorArredondamento)) {
                const informada = dados.notaInformada || dados.NotaInformada;
                const salva = dados.notaSalva || dados.NotaSalva;
                yield put(showSuccessMessage(`Nota ajustada de ${informada} para ${salva} pelo arredondamento da regra.`));
            } else {
                yield put(showSuccessMessage('Nota/Falta salva com sucesso!'));
            }

            // Atualizar estado local com dados do backend (arredondamentos, etc)
            if (dados) {
                yield put(salvaNotaFaltaSucesso(dados));
            }
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao salvar');
        yield put(showAuthMessage(mensagem));
    }
}

// Saga para salvar parecer descritivo
function* fnSalvaParecerDescritivo({ payload }) {
    try {
        const retorno = yield call(postSalvaParecerDescritivo, payload);

        // Verificar se houve erro na resposta
        if (retorno.response || retorno.message || (retorno.mensagem && !retorno.data)) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao salvar parecer');
            yield put(showAuthMessage(mensagem));
        } else {
            // Sucesso
            yield put(showSuccessMessage('Parecer salvo com sucesso!'));
            // Atualizar estado local
            yield put(salvaParecerDescritivoSucesso(payload));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao salvar parecer');
        yield put(showAuthMessage(mensagem));
    }
}

// Saga para salvar nota do conselho
function* fnSalvaNotaConselho({ payload }) {
    try {
        const retorno = yield call(postSalvaNotaConselho, payload);

        // Verificar se houve erro na resposta
        if (retorno.response || retorno.message || (retorno.mensagem && !retorno.data)) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao salvar nota do conselho');
            yield put(showAuthMessage(mensagem));
        } else {
            // Sucesso
            yield put(showSuccessMessage('Nota do conselho salva com sucesso!'));
            // Atualizar estado local
            if (retorno.data && retorno.data.dados) {
                yield put(salvaNotaConselhoSucesso(retorno.data.dados));
            } else {
                yield put(salvaNotaConselhoSucesso(payload));
            }
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao salvar nota do conselho');
        yield put(showAuthMessage(mensagem));
    }
}

// Saga para salvar nota de recuperação
function* fnSalvaNotaRecuperacao({ payload }) {
    try {
        const retorno = yield call(postSalvaNotaRecuperacao, payload);

        if (retorno.response || retorno.message || (retorno.mensagem && !retorno.data)) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao salvar recuperação');
            yield put(showAuthMessage(mensagem));
        } else {
            yield put(showSuccessMessage('Recuperação proccessada com sucesso.'));
            // Merge do payload de envio com o retorno para garantir IDs na atualização
            const dadosCompletos = {
                ...payload,
                ...(retorno.data ? retorno.data.dados : {})
            };
            yield put(salvaNotaRecuperacaoSucesso(dadosCompletos));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao salvar recuperação');
        yield put(showAuthMessage(mensagem));
    }
}

// Saga para salvar situação da matrícula
function* fnSalvaSituacaoMatricula({ payload }) {
    try {
        const retorno = yield call(putAtualizaSituacaoMatricula, payload);

        if (retorno.response || retorno.message || (retorno.mensagem && !retorno.data)) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao salvar situação');
            yield put(showAuthMessage(mensagem));
            yield put(salvaSituacaoMatriculaSucesso({ situacao: null }));
        } else {
            yield put(showSuccessMessage('Situação da matrícula atualizada com sucesso!'));
            // Atualizar estado local
            yield put(salvaSituacaoMatriculaSucesso(payload));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao salvar situação');
        yield put(showAuthMessage(mensagem));
        // Reset loading state on error
        yield put(salvaSituacaoMatriculaSucesso({ situacao: null }));
    }
}

/*#################################################################################################################*/
/* -------------------------------------- Exportação das Sagas ----------------------------------------------------*/

export function* iniciaAcoesNotasFaltas() {
    yield takeEvery(INICIA_NOTAS_FALTAS, fnIniciaNotasFaltas);
}

export function* listaCursosNotasFaltas() {
    yield takeEvery(LISTA_CURSOS_NOTAS_FALTAS, fnListaCursosNotasFaltas);
}

export function* listaSeriesNotasFaltas() {
    yield takeEvery(LISTA_SERIES_NOTAS_FALTAS, fnListaSeriesNotasFaltas);
}

export function* listaTurmasNotasFaltas() {
    yield takeEvery(LISTA_TURMAS_NOTAS_FALTAS, fnListaTurmasNotasFaltas);
}

export function* listaEtapasNotasFaltas() {
    yield takeEvery(LISTA_ETAPAS_NOTAS_FALTAS, fnListaEtapasNotasFaltas);
}

export function* listaDisciplinasNotasFaltas() {
    yield takeEvery(LISTA_DISCIPLINAS_NOTAS_FALTAS, fnListaDisciplinasNotasFaltas);
}

export function* listaMatriculasNotasFaltas() {
    yield takeEvery(LISTA_MATRICULAS_NOTAS_FALTAS, fnListaMatriculasNotasFaltas);
}

export function* buscaNotasFaltas() {
    yield takeEvery(BUSCA_NOTAS_FALTAS, fnBuscaNotasFaltas);
}

export function* salvaNotaFalta() {
    yield takeEvery(SALVA_NOTA_FALTA, fnSalvaNotaFalta);
}

export function* salvaParecerDescritivo() {
    yield takeEvery(SALVA_PARECER_DESCRITIVO, fnSalvaParecerDescritivo);
}

export function* salvaNotaConselho() {
    yield takeEvery(SALVA_NOTA_CONSELHO, fnSalvaNotaConselho);
}

export function* salvaNotaRecuperacao() {
    yield takeEvery(SALVA_NOTA_RECUPERACAO, fnSalvaNotaRecuperacao);
}

export function* salvaSituacaoMatricula() {
    yield takeEvery(SALVA_SITUACAO_MATRICULA, fnSalvaSituacaoMatricula);
}

export default function* rootSaga() {
    yield all([
        fork(iniciaAcoesNotasFaltas),
        fork(listaCursosNotasFaltas),
        fork(listaSeriesNotasFaltas),
        fork(listaTurmasNotasFaltas),
        fork(listaEtapasNotasFaltas),
        fork(listaDisciplinasNotasFaltas),
        fork(listaMatriculasNotasFaltas),
        fork(buscaNotasFaltas),
        fork(salvaNotaFalta),
        fork(salvaParecerDescritivo),
        fork(salvaNotaConselho),
        fork(salvaNotaRecuperacao),
        fork(salvaSituacaoMatricula)
    ]);
}
